import React, { useEffect, useState, useCallback } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { DatePicker, Spin, Tabs } from "antd";
import Select from "react-select";
import Swal from "sweetalert2";
import axios from "axios";
import dayjs from "dayjs";

import { BASE_CRM_URL } from "../../../../components/config/config";
// import ProductTable from "../../../../../core/pagination/ProductTable";
import CommonFooter from "../../../../../core/common/footer/commonFooter";
import EditProducttable from "../../../../../core/pagination/EditProducttable";

const Update = () => {
  const { type, id } = useParams();
  const navigate = useNavigate();

  const isProposal = type === "proposal";
  const isEstimate = type === "estimate";
  const isInvoice = type === "invoice";
  const isCreditNote = type === "creditnote";

  const showAddressFields = isEstimate || isInvoice || isCreditNote;

  const [loading, setLoading] = useState(false);
  console.log(loading);
  const [saving, setSaving] = useState(false);

  const [viewDetails, setViewDetails] = useState(null);

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [customerOptions, setCustomerOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [countries, setCountries] = useState([]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [formData, setFormData] = useState({
    adminnote: "",
    clientnote: "",
    terms: "",
    reference_no: "",

    street: "",
    city: "",
    state: "",
    zip: "",

    subject: "",
    content: "",
    proposal_to: "",
    email: "",
    phone: "",

    project_id: null,
  });

  const [productData, setProductData] = useState({
    items: [],
    subtotal: 0,
    discount: 0,
    discountAmount: 0,
    discount_percent: 0,
    discount_total: 0,
    discountType: "",
    discountTypeId: null,
    discountMethod: "",
    taxes: [],
    totalTax: 0,
    adjustment: 0,
    total: 0,
    currencyId: null,
    currencyName: "",
  });

  console.log(productData, "productdataaaaaaaaaaaaaa");

  // const [isPrefilled, setIsPrefilled] = useState(false);

  const firstDateLabels = {
    proposal: "Date",
    estimate: "Estimated Date",
    creditnote: "Credit Note Date",
    invoice: "Invoice Date",
  };

  const secondDateLabels = {
    proposal: "Open Till",
    estimate: "Expiry Date",
    invoice: "Due Date",
  };

  const firstDateLabel = firstDateLabels[type];
  const secondDateLabel = secondDateLabels[type];

  // const prefillStyle = isPrefilled
  //   ? {
  //       backgroundColor: "#EAF4FF",
  //       border: "1px solid #8CC4FF",
  //     }
  //   : {};
  // const prefillSelectStyles = isPrefilled
  //   ? {
  //       control: (provided) => ({
  //         ...provided,
  //         backgroundColor: "#EAF4FF",
  //         borderColor: "#8CC4FF",
  //         boxShadow: "none",
  //         "&:hover": {
  //           borderColor: "#8CC4FF",
  //         },
  //       }),
  //     }
  //   : {};

  const backPaths = {
    estimate: "/crm/estimates",
    invoice: "/crm/invoices",
    creditnote: "/crm/creditnotes",
    proposal: "/crm/proposals",
  };

  const formattedType = type
    ? type.charAt(0).toUpperCase() + type.slice(1)
    : "";
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;
  console.log(userId);

  const { state } = useLocation();

  console.log(state, "state................................");

  console.log("Customer ID:", state?.record?.rel_id);
  const customermainid = state?.record?.rel_id;
  console.log(customermainid);

  const [countryLoading, setCountryLoading] = useState(false);

  const [leadOptions, setLeadOptions] = useState([]);

  const [isCustomerPrefilled, setIsCustomerPrefilled] = useState(false);

  const [relatedOptions, setRelatedOptions] = useState([]);
  const [relatedLoading, setRelatedLoading] = useState(false);
  const [selectedRelated, setSelectedRelated] = useState(null);

  const [selectedLead, setSelectedLead] = useState(null);

  const [selectedRelatedName, setSelectedRelatedName] = useState("");

  const [projectLoading, setProjectLoading] = useState(false);

  //   const [isReadOnly, setIsReadOnly] = useState(false);

  const getDetails = async () => {
    try {
      setLoading(true);

      let endpoint = "";

      switch (type) {
        case "proposal":
          endpoint = `proposal/GetProposal/${id}`;
          break;

        case "estimate":
          endpoint = `estimates/GetEstimate/${id}`;
          break;

        case "invoice":
          endpoint = `invoice/GetInvoice/${id}`;
          break;

        case "creditnote":
          endpoint = `creditnotes/GetCreditNote/${id}`;
          break;

        default:
          throw new Error("Invalid document type");
      }

      const response = await axios.get(`${BASE_CRM_URL}${endpoint}`);

      if (response.data.Status) {
        const data = response.data.ResultData || response.data.Data;

        setViewDetails(data);

        console.log("EDIT DATA:", data);

        prefillForm(data);
      }
    } catch (error) {
      console.error("Get Edit Details Error:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.Message || "Failed to fetch details",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id && type) {
      getDetails();
    }
  }, [id, type]);

  const prefillForm = (data) => {
    if (!data) return;

    setFormData({
      adminnote: data.adminnote || "",
      clientnote: data.clientnote || "",
      terms: data.terms || "",
      reference_no: data.reference_no || "",

      street: data.billing_street || data.address || "",

      city: data.billing_city || data.city || "",

      state: data.billing_state || data.state || "",

      zip: data.billing_zip || data.zip || "",

      subject: data.subject || "",
      content: data.content || "",

      proposal_to: data.proposal_to || data.ClientName || data.company || "",

      email: data.email || data.MailId || "",

      phone: data.phone || data.PhoneNumber || "",

      project_id: data.project_id || null,

      currency: data.currency || null,
    });

    if (type === "proposal") {
      if (data.rel_type === "customer") {
        setSelectedRelatedName("Customer");

        setSelectedCustomer({
          value: data.rel_id,
          label: data.ClientName || data.company || "",
        });
      }

      if (data.rel_type === "lead") {
        setSelectedRelatedName("Lead");

        setSelectedLead({
          value: data.rel_id,
          label: data.ClientName || data.company || "",
        });
      }
      getProjects(data.rel_id, data.project_id);
    }

    if (type !== "proposal") {
      setSelectedCustomer({
        value: data.clientid,
        label: data.ClientName || data.company || "",
      });
    }

    setSelectedCountry({
      value: data.billing_country,
      label: data.CountryName,
    });

    setSelectedRelated({
      value: data.RelatedTypeId,
      label: data.RelatedTypeName,
    });

    // if (data.project_id) {

    //   setFormData({
    //     ...
    //     project_id: data.project_id,
    //   });
    // }

    if (
      data.date ||
      data.due_date ||
      data.dueDate ||
      data.open_till ||
      data.datecreated
    ) {
      setStartDate(
        dayjs(
          data.date ||
            data.due_date ||
            data.dueDate ||
            data.open_till ||
            data.datecreated,
        ),
      );
    }

    if (data.expirydate || data.due_date || data.dueDate || data.open_till) {
      setEndDate(
        dayjs(
          data.expirydate || data.due_date || data.dueDate || data.open_till,
        ),
      );
    }

    // -------------------------
    // PRODUCT DATA
    // -------------------------

    setProductData({
      items: normalizeItems(data.items || data.Itemable || []),

      subtotal: Number(data.subtotal || 0),

      discount:
        data.discount_percent > 0 ? data.discount_percent : data.discount_total,

      discountAmount: Number(data.discount_total || data.discountAmount || 0),

      discountType: data.discount_type_name,
      discount_percent: data.discount_percent,
      discount_total: data.discount_total,

      discountTypeId: Number(data.discount_type_id || data.discount_type || 0),

      taxes: data.taxes || [],

      totalTax: Number(data.total_tax || data.totalTax || 0),

      adjustment: Number(data.adjustment || 0),

      total: Number(data.total || 0),

      currencyId: data.currency_id || data.currency || null,
      currencyName: data.currencyName || "",
    });

    // setIsReadOnly(true);
    // setIsPrefilled(true);
  };

  const normalizeItems = (items) => {
    return items.map((item, index) => ({
      id:
        item.id ??
        `existing-${item.productId || item.item_id || item.itemid || index}`,
      productId: item.productId || item.item_id || item.itemid || item.id,
      item: item.item || item.description || "",
      description: item.long_description || item.description || "",
      qty: Number(item.qty || item.quantity || 1),
      rate: Number(item.rate || 0),
      unit: item.unit || "",
      taxes: item.taxes || item.item_taxes || [],
      hsn: item.HSNCode || item.hsn || "", // ← consistent name
    }));
  };

  const getRelatedTypes = async () => {
    try {
      setRelatedLoading(true);

      const response = await fetch(`${BASE_CRM_URL}RelatedToType`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.RelatedToType,
          name: item.RelatedToType,
        }));

        setRelatedOptions(options);
      }
    } catch (error) {
      console.error("Error fetching related types:", error);
    } finally {
      setRelatedLoading(false);
    }
  };

  const getCustomers = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}customers/GetCustomers`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.customerId,
          label: item.company,
        }));

        setCustomerOptions(options);
      }
    } catch (error) {
      console.error("Error fetching related types:", error);
    }
  };
  const getLeads = async () => {
    try {
      // setRelatedLoading(true);

      const response = await fetch(`${BASE_CRM_URL}leads/GetLeads`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setLeadOptions(options);

        // // Optional: Set first option as default
        // if (options.length > 0) {
        //   setSelectedRelated(options[0].value);
        // }
      }
    } catch (error) {
      console.error("Error fetching related types:", error);
    } finally {
      setRelatedLoading(false);
    }
  };

  const getCustomerDetails = async (customerId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}customers/GetCustomerDetails?CusId=${customerId}`,
      );

      const data = await response.json();

      if (data.Status && data.ResultData?.length > 0) {
        fillCustomerDetails(data.ResultData[0]);
        setIsCustomerPrefilled(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getCountries = async () => {
    try {
      setCountryLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetCountries`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.country_id,
          label: item.short_name,
        }));

        setCountries(options);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
      setCountryLoading(false);
    }
  };

  const getLeadDetails = async (leadId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}leads/GetLeadById?LeadId=${leadId}`,
      );

      const data = await response.json();

      if (data.Status) {
        const lead = data.ResultData;

        setFormData((prev) => ({
          ...prev,
          proposal_to: lead.name || "",
          email: lead.email || "",
          phone: lead.phonenumber || "",
          address: lead.address || "",
          city: lead.city || "",
          state: lead.state || "",
          zip: lead.zip || "",
          country: lead.country || null,
          rel_id: lead.id,
          rel_type: "lead",
        }));

        setSelectedCountry(
          countries.find((c) => c.value === lead.country) || null,
        );
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getProjects = async (customerId, projectId = null) => {
    try {
      setProjectLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}project/GetProjectsByCusId?CusID=${customerId}`,
      );

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setProjectOptions(options);
        if (projectId) {
          const selected = options.find(
            (option) => Number(option.value) === Number(projectId),
          );

          setSelectedProject(selected || null);
        }
      } else {
        setProjectOptions([]);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
      setProjectOptions([]);
    } finally {
      setProjectLoading(false);
    }
  };

  useEffect(() => {
    getCountries();
    getLeads();
    getRelatedTypes();
    getCustomers();
  }, []);

  useEffect(() => {
    if (!state || relatedOptions.length === 0) return;

    console.log("State.......:", state);
    console.log("State Type:", state?.type);

    // =====================================================
    // LEAD
    // =====================================================
    if (state.type === "lead") {
      const lead = state.record;

      // Select "Lead" in Related dropdown
      const related = relatedOptions.find(
        (item) => item.label?.toLowerCase() === "lead",
      );

      setSelectedRelated(related || null);
      setSelectedRelatedName("Lead");

      // Fill all lead details
      fillLeadDetails(lead);

      return;
    }

    // =====================================================
    // CUSTOMER
    // =====================================================
    if (state.type === "customer") {
      const customer = state.record;

      // Select "Customer" in Related dropdown
      const related = relatedOptions.find(
        (item) => item.label?.toLowerCase() === "customer",
      );

      setSelectedRelated(related || null);
      setSelectedRelatedName("Customer");

      // Fill all customer details
      fillCustomerDetails(customer);

      // Load projects
      if (customer?.customerId) {
        getProjects(customer.customerId);
      }

      return;
    }
  }, [state, relatedOptions, countries]);

  const fillLeadDetails = (lead) => {
    console.log("Lead Data:", lead);

    if (!lead) return;

    setFormData((prev) => ({
      ...prev,
      proposal_to: lead.name || "",
      email: lead.email || "",
      phone: lead.phonenumber || "",
      address: lead.address || "",
      city: lead.city || "",
      state: lead.state || "",
      zip: lead.zip || "",
      country: lead.country || null,
      rel_id: lead.id,
      rel_type: "lead",
    }));

    // setIsPrefilled(true);
    // setIsReadOnly(true);

    setSelectedLead({
      value: lead.id,
      label: lead.name,
    });

    setSelectedCountry(
      countries.find((c) => Number(c.value) === Number(lead.country)) || null,
    );
  };

  const fillCustomerDetails = (customer) => {
    console.log("Customer Data:", customer);

    if (!customer) return;

    setFormData((prev) => ({
      ...prev,
      proposal_to: customer.company || "",
      email: customer.email || "",
      phone: customer.phonenumber || "",
      address: customer.address || "",
      city: customer.city || "",
      state: customer.state || "",
      zip: customer.zip || "",
      country: customer.country || null,
      rel_id: customer.customerId,
      rel_type: "customer",
      currency: customer.default_currency,
    }));

    // setIsPrefilled(true);
    // setIsReadOnly(true);

    setSelectedCustomer({
      value: customer.customerId,
      label: customer.company,
    });

    setSelectedCountry(
      countries.find((c) => Number(c.value) === Number(customer.country)) ||
        null,
    );
  };

  const isLeadRelated = selectedRelatedName?.toLowerCase() === "lead";
  console.log(isLeadRelated);

  const buildItemsPayload = () => {
    return (productData?.items || []).map((item) => ({
      item_id: item.productId || item.item_id || item.id,

      description: item.item || item.description || "",

      long_description: item.description || item.long_description || "",

      qty: Number(item.qty || 0),

      rate: Number(item.rate || 0),

      unit: item.unit || "",

      item_taxes: Array.isArray(item.taxes)
        ? item.taxes.map((tax) => ({
            taxrate: Number(tax.taxrate || 0),

            taxname: tax.label || tax.taxname || "",
          }))
        : [],
    }));
  };

  const handleProductDataChange = useCallback((updatedData) => {
    setProductData((prev) => ({
      ...prev,
      ...updatedData,
    }));
  }, []);

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);

      const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));

      const userId = userDetails?.staffid;

      let endpoint = "";
      let payload = {};

      switch (type) {
        case "estimate":
          endpoint = "estimates/UpdateEstimate";

          payload = {
            id: Number(id),

            clientid: selectedCustomer?.value || 0,

            project_id: Number(selectedProject?.value || 0),

            number: Number(viewDetails?.number || 0),

            prefix: viewDetails?.prefix || "EST-",

            date: startDate ? startDate.format("YYYY-MM-DD") : null,

            expirydate: endDate ? endDate.format("YYYY-MM-DD") : null,

            currency: productData?.currencyId || 0,

            subtotal: Number(productData?.subtotal || 0),

            total_tax: Number(productData?.totalTax || 0),

            total: Number(productData?.total || 0),

            adjustment: Number(productData?.adjustment || 0),

            addedfrom: userId,
            sale_agent: viewDetails?.sale_agent || userId,

            status: Number(viewDetails?.status || 1),

            clientnote: formData.clientnote || "",

            adminnote: formData.adminnote || "",

            terms: formData.terms || "",

            reference_no: formData.reference_no || "",

            discount_percent: Number(productData?.discount_percent || 0),

            discount_total: Number(productData?.discount_total || 0),

            discount_type: productData?.discountTypeId,

            billing_street: formData.street || "",

            billing_city: formData.city || "",

            billing_state: formData.state || "",

            billing_zip: formData.zip || "",

            billing_country: selectedCountry?.value || 0,
            shipping_street: formData.shipping_street || "",

            shipping_city: formData.shipping_city || "",

            shipping_state: formData.shipping_state || "",

            shipping_zip: formData.shipping_zip || "",

            shipping_country: Number(
              formData.shipping_country || selectedCountry?.value || 0,
            ),

            items: buildItemsPayload(),
          };

          break;

        case "invoice":
          endpoint = "invoice/UpdateInvoice";

          payload = {
            id: Number(id),

            clientid: selectedCustomer?.value || 0,

            number: Number(viewDetails?.number || 0),

            prefix: viewDetails?.prefix || "INV-",

            date: startDate ? startDate.format("YYYY-MM-DD") : null,

            duedate: endDate ? endDate.format("YYYY-MM-DD") : null,

            currency: productData?.currencyId || 0,

            subtotal: Number(productData?.subtotal || 0),

            total_tax: Number(productData?.totalTax || 0),

            total: Number(productData?.total || 0),

            adjustment: Number(productData?.adjustment || 0),

            addedfrom: userId,

            status: Number(viewDetails?.status || 1),

            sale_agent: viewDetails?.sale_agent || userId,

            clientnote: formData.clientnote || "",

            adminnote: formData.adminnote || "",

            terms: formData.terms || "",

            discount_percent: Number(productData?.discount_percent || 0),

            discount_total: Number(productData?.discount_total || 0),

            discount_type: productData?.discountTypeId,

            billing_street: formData.street || "",

            billing_city: formData.city || "",

            billing_state: formData.state || "",

            billing_zip: formData.zip || "",

            billing_country: selectedCountry?.value || 0,
            shipping_street: formData.shipping_street || "",

            shipping_city: formData.shipping_city || "",

            shipping_state: formData.shipping_state || "",

            shipping_zip: formData.shipping_zip || "",

            shipping_country: Number(
              formData.shipping_country || selectedCountry?.value || 0,
            ),

            items: buildItemsPayload(),
          };

          break;

        case "creditnote":
          endpoint = "creditnotes/UpdateCreditNote";

          payload = {
            id: Number(id),

            clientid: selectedCustomer?.value || 0,

            date: startDate ? startDate.format("YYYY-MM-DD") : null,

            currency: productData?.currencyId || 0,

            subtotal: Number(productData?.subtotal || 0),

            total_tax: Number(productData?.totalTax || 0),

            total: Number(productData?.total || 0),

            adjustment: Number(productData?.adjustment || 0),

            adminnote: formData.adminnote || "",

            clientnote: formData.clientnote || "",

            terms: formData.terms || "",

            reference_no: formData.reference_no || "",

            project_id: Number(selectedProject?.value || 0),

            discount_percent: Number(productData?.discount_percent || 0),

            discount_total: Number(productData?.discount_total || 0),

            discount_type: productData?.discountTypeId,

            billing_street: formData.street || "",

            billing_city: formData.city || "",

            billing_state: formData.state || "",

            billing_zip: formData.zip || "",

            billing_country: selectedCountry?.value || 0,

            items: buildItemsPayload(),
          };

          break;

        case "proposal":
          endpoint = "proposal/UpdateProposal";

          payload = {
            id: Number(id),

            subject: formData.subject || "",
            content: formData.content || "",

            rel_id:
              selectedRelatedName?.toLowerCase() === "lead"
                ? selectedLead?.value || 0
                : selectedCustomer?.value || 0,

            rel_type:
              selectedRelatedName?.toLowerCase() === "lead"
                ? "lead"
                : "customer",

            proposal_to: formData.proposal_to || "",
            email: formData.email || "",
            phone: formData.phone || "",

            address: formData.street || "",
            city: formData.city || "",
            state: formData.state || "",
            zip: formData.zip || "",
            assigned: userId,
            addedfrom: userId,
            hash: "",

            status: Number(viewDetails?.status || 1),

            country: selectedCountry?.value || viewDetails?.country,

            project_id: Number(selectedProject?.value || 0),

            date: startDate ? startDate.format("YYYY-MM-DD") : null,
            open_till: endDate ? endDate.format("YYYY-MM-DD") : null,

            subtotal: Number(productData?.subtotal || 0),
            total_tax: Number(productData?.totalTax || 0),
            total: Number(productData?.total || 0),
            adjustment: Number(productData?.adjustment || 0),

            discount_percent: Number(productData?.discount_percent || 0),

            discount_total: Number(productData?.discount_total || 0),
            discount_type: productData?.discountTypeId,

            currency: productData?.currencyId || 0,

            items: buildItemsPayload(),
          };

          break;

        default:
          throw new Error("Invalid document type");
      }

      console.log("UPDATE PAYLOAD:", payload);

      const response = await axios.post(`${BASE_CRM_URL}${endpoint}`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.data.Status) {
        await Swal.fire({
          icon: "success",
          title: "Updated Successfully",
          text: response.data.Message,
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          if (state?.type === "customer") {
            navigate(`/crm/customerinfo/${customermainid}`);
            return;
          }
          if (state?.type === "lead") {
            navigate(`/crm/viewleads/${customermainid}`);
            return;
          }

          navigate(backPaths[type]);
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: response.data.Message,
        });
      }
    } catch (error) {
      console.error("Update Error:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.Message ||
          error.message ||
          "Something went wrong",
      });
    } finally {
      setSaving(false);
    }
  };

  const [activeTab, setActiveTab] = useState("basic");
  const handleNext = () => {
    const tabKeys = tabItems.map((tab) => tab.key);
    const currentIndex = tabKeys.indexOf(activeTab);
    if (currentIndex < tabKeys.length - 1) {
      setActiveTab(tabKeys[currentIndex + 1]);
    }
  };
  const handlePrevious = () => {
    const tabKeys = tabItems.map((tab) => tab.key);
    const currentIndex = tabKeys.indexOf(activeTab);
    if (currentIndex > 0) {
      setActiveTab(tabKeys[currentIndex - 1]);
    }
  };
  useEffect(() => {
    if (selectedCustomer?.value && formData.project_id) {
      getProjects(selectedCustomer.value, formData.project_id);
    }
  }, [selectedCustomer?.value, formData.project_id]);

  const tabItems = [
    {
      key: "basic",
      label: (
        <>
          <i className="bi bi-person-lines-fill me-2"></i>
          Customer
        </>
      ),
      children: (
        <>
          {/* ===================================================== */}
          {/* PROPOSAL ONLY                                         */}
          {/* Subject, Related, Lead, Customer, Project, Email,     */}
          {/* Phone                                                 */}
          {/* ===================================================== */}

          <div className="row">
            {isProposal && (
              <>
                {/* Subject */}
                <div className="col-4 mb-2">
                  <label>Subject</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Subject"
                    value={formData.subject}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        subject: e.target.value,
                      }))
                    }
                  />
                </div>

                {/* Related */}
                <div className="col-2 mb-2">
                  <label>Related (Customer/Lead)</label>

                  <Select
                    options={relatedOptions}
                    value={selectedRelated}
                    // styles={prefillSelectStyles}
                    // isDisabled={isSelectReadOnly(selectedRelated)}
                    loading={relatedLoading}
                    placeholder="Select Related"
                    onChange={(value) => {
                      console.log("Selected Value:@@@@@@@@@", value);

                      setSelectedRelated(value);
                      setSelectedRelatedName(value?.name);

                      setSelectedLead(null);
                      setSelectedCustomer(null);
                      setSelectedProject(null);
                    }}
                  />
                </div>

                {/* Lead */}
                {selectedRelatedName === "Lead" && (
                  <div className="col-3 mb-3">
                    <label>Lead</label>

                    <Select
                      options={leadOptions}
                      value={selectedLead}
                      //   styles={prefillSelectStyles}
                      //   isDisabled={isSelectReadOnly(selectedLead)}
                      placeholder="Select Lead"
                      onChange={async (option) => {
                        setSelectedLead(option);

                        if (option?.value) {
                          await getLeadDetails(option.value);
                        }
                      }}
                    />
                  </div>
                )}

                {/* Customer - Proposal */}
                {selectedRelatedName === "Customer" && (
                  <div className="col-3 mb-3">
                    <label>Customer</label>

                    <Select
                      // options={customerOptions}
                      // value={selectedCustomer}
                      // styles={prefillSelectStyles}
                      // isDisabled={isSelectReadOnly(selectedCustomer)}
                      // placeholder="Select Customer"
                      // onChange={async (option) => {
                      //   setSelectedCustomer(option);

                      //   if (option?.value) {
                      //     await getCustomerDetails(option.value);
                      //     getProjects(option.value);
                      //   }
                      // }}
                      isSearchable
                      placeholder="Select Customer"
                      className={`w-100 ${
                        isCustomerPrefilled ? "prefilled-select" : ""
                      }`}
                      style={{ height: 38 }}
                      options={customerOptions}
                      value={selectedCustomer}
                      onChange={(value) => {
                        setSelectedCustomer(value.value);
                        getCustomerDetails(value.value);
                        getProjects(value.value);
                      }}
                      //   onChange={(option) => {
                      //     setSelectedCustomer(option);

                      //     if (option?.value) {
                      //       getCustomerDetails(option.value);
                      //       getProjects(option.value);
                      //     }
                      //   }}
                    />
                  </div>
                )}

                {/* Project */}
                {selectedCustomer && (
                  <div className="col-3 mb-3">
                    <label>Project</label>

                    <Select
                      options={projectOptions}
                      //   isDisabled={isSelectReadOnly(selectedProject)}
                      //   styles={prefillSelectStyles}
                      value={selectedProject}
                      isLoading={projectLoading}
                      placeholder="Select Project"
                      onChange={(option) => setSelectedProject(option)}
                    />
                  </div>
                )}

                {/* Email */}
                <div className="col-3 mb-2">
                  <label>Email</label>

                  <input
                    type="email"
                    className="form-control"
                    // style={prefillStyle}
                    // disabled={isReadOnly && !!formData.email}
                    placeholder="Enter Email"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        email: e.target.value,
                      }))
                    }
                  />
                </div>

                {/* Phone */}
                <div className="col-3 mb-2">
                  <label>Phone</label>

                  <input
                    type="text"
                    className="form-control"
                    // style={prefillStyle}
                    // disabled={isReadOnly && !!formData.phone}
                    placeholder="Enter PhoneNumber"
                    value={formData.phone}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        phone: e.target.value,
                      }))
                    }
                  />
                </div>
              </>
            )}

            {/* ===================================================== */}
            {/* CUSTOMER                                              */}
            {/* Estimate / Credit Note / Invoice                      */}
            {/* One reusable Customer dropdown                        */}
            {/* ===================================================== */}

            {/* <div className="row"> */}
            {/* {!isProposal && (
              <div className="mb-2 col-3">
                <label>Customer</label>

                <Select
                  showSearch
                  placeholder="Select Customer"
                  optionFilterProp="label"
                  className={`w-100 ${
                    isCustomerPrefilled ? "prefilled-select" : ""
                  }`}
                  options={customerOptions}
                  value={selectedCustomer}
                  onChange={(value) => {
                    console.log(value, "valuuuuuuuuuuuuuuuuuuuuu");
                    setSelectedCustomer(value.value);
                    getCustomerDetails(value.value);
                  }}
                  //   onChange={(option) => {
                  //     setSelectedCustomer(option);

                  //     if (option?.value) {
                  //       getCustomerDetails(option.value);
                  //       getProjects(option.value);
                  //     }
                  //   }}
                />

                
              </div>

              
              
              
            )} */}
            {!isProposal && (
              <>
                <div className="mb-2 col-3">
                  <label>Customer</label>

                  <Select
                    // showSearch
                    // placeholder="Select Customer"
                    // optionFilterProp="label"
                    // className={`w-100 ${
                    //   isCustomerPrefilled ? "prefilled-select" : ""
                    // }`}
                    // options={customerOptions}
                    // value={selectedCustomer}
                    // onChange={(value) => {
                    //   console.log(value, "valuuuuuuuuuuuuuuuuuuu");

                    //   setSelectedCustomer(value);
                    //   getCustomerDetails(value);
                    //   getProjects(value);
                    // }}
                    isSearchable
                    placeholder="Select Customer"
                    className={`w-100 ${
                      isCustomerPrefilled ? "prefilled-select" : ""
                    }`}
                    style={{ height: 38 }}
                    options={customerOptions}
                    value={selectedCustomer}
                    onChange={(value) => {
                      setSelectedCustomer(value.value);
                      getCustomerDetails(value.value);
                      getProjects(value.value);
                    }}
                  />
                </div>

                {selectedCustomer && (
                  <div className="col-3 mb-3">
                    <label>Project</label>

                    <Select
                      options={projectOptions}
                      //   isDisabled={isSelectReadOnly(selectedProject)}
                      //   styles={prefillSelectStyles}
                      value={selectedProject}
                      isLoading={projectLoading}
                      placeholder="Select Project"
                      onChange={(option) => setSelectedProject(option)}
                    />
                  </div>
                )}
              </>
            )}

            {/* ===================================================== */}
            {/* DATE FIELDS                                           */}
            {/* One reusable first date                              */}
            {/* ===================================================== */}

            <div className="mb-2 col-3">
              <label>{firstDateLabel}</label>

              <DatePicker
                value={startDate}
                format="DD-MM-YYYY"
                // style={prefillStyle}
                className="w-100"
                onChange={(date) => {
                  setStartDate(date);

                  /*
                   * Proposal and Estimate automatically
                   * set the second date to +15 days.
                   */
                  if ((isProposal || isEstimate) && date) {
                    setEndDate(date.add(15, "day"));
                  } else if (isProposal || isEstimate) {
                    setEndDate(null);
                  }
                }}
              />
            </div>

            {/* ================================================= */}
            {/* SECOND DATE                                        */}
            {/* Proposal  -> Open Till                            */}
            {/* Estimate  -> Expiry Date                          */}
            {/* Invoice   -> Due Date                             */}
            {/* Credit Note -> No second date                     */}
            {/* ================================================= */}

            {(isProposal || isEstimate || isInvoice) && (
              <div className="mb-2 col-3">
                <label>{secondDateLabel}</label>

                <DatePicker
                  value={endDate}
                  format="DD-MM-YYYY"
                  //   style={prefillStyle}
                  className="w-100"
                  onChange={(date) => setEndDate(date)}
                />
              </div>
            )}

            {/* ================================================= */}
            {/* REFERENCE NUMBER                                   */}
            {/* Estimate + Credit Note                            */}
            {/* ================================================= */}

            {(isEstimate || isCreditNote) && (
              <div className="mb-2 col-3">
                <label>Reference #</label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Reference #"
                  //   style={prefillStyle}
                  value={formData.reference_no || ""}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      reference_no: e.target.value,
                    }))
                  }
                  required
                />
              </div>
            )}
            {/* </div> */}
            {/* ===================================================== */}
            {/* COMMON ADDRESS                                        */}
            {/* Estimate + Credit Note + Invoice                      */}
            {/* One copy only                                         */}
            {/* ===================================================== */}

            {showAddressFields && (
              <>
                {/* Street */}
                <div className="mb-2 col-3">
                  <label>(Bill To) Street</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Street"
                    // style={prefillStyle}
                    value={formData.street}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        street: e.target.value,
                      }))
                    }
                  />
                </div>

                {/* City */}
                <div className="mb-2 col-3">
                  <label>City</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter City"
                    // style={prefillStyle}
                    value={formData.city}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        city: e.target.value,
                      }))
                    }
                  />
                </div>

                {/* State */}
                <div className="mb-2 col-3">
                  <label>State</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter State"
                    // style={prefillStyle}
                    value={formData.state}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        state: e.target.value,
                      }))
                    }
                  />
                </div>

                {/* Zip Code */}
                <div className="mb-2 col-3">
                  <label>Zip Code</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Zip Code"
                    // style={prefillStyle}
                    value={formData.zip}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        zip: e.target.value,
                      }))
                    }
                  />
                </div>

                {/* Country */}
                <div className="mb-2 col-3">
                  <label>Country</label>

                  <Select
                    className={`w-100 ${
                      isCustomerPrefilled ? "prefilled-select" : ""
                    }`}
                    placeholder="Select Country"
                    options={countries}
                    value={selectedCountry}
                    // style={prefillStyle}
                    loading={countryLoading}
                    onChange={(value) => {
                      setSelectedCountry(value);
                      setIsCustomerPrefilled(false);
                    }}
                    showSearch
                    optionFilterProp="label"
                    // filterOption={(input, option) =>
                    //   (option?.label ?? "")
                    //     .toLowerCase()
                    //     .includes(input.toLowerCase())
                    // }
                  />
                </div>

                {/* Admin Note */}
                <div
                  className={`mb-2 ${
                    ["creditnote", "invoice"].includes(type)
                      ? "col-12"
                      : "col-9"
                  }`}
                >
                  <label>Admin Note(Internal)</label>

                  <textarea
                    className="form-control"
                    placeholder="Enter text here"
                    // style={prefillStyle}
                    rows="1"
                    value={formData.adminnote}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        adminnote: e.target.value,
                      }))
                    }
                  />
                </div>
              </>
            )}
          </div>
        </>
      ),
    },

    ...(type !== "estimate" && type !== "creditnote" && type !== "invoice"
      ? [
          {
            key: "address",
            label: (
              <>
                <i className="bi bi-geo-alt me-2"></i>
                Address
              </>
            ),
            children: (
              <>
                <div className="row">
                  <div className="col-4 mb-3">
                    <label>To</label>
                    <textarea
                      className="form-control"
                      placeholder="Eneter Name"
                      // style={prefillStyle}
                      //   disabled={isReadOnly && !!formData.proposal_to}
                      value={formData.proposal_to}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          proposal_to: e.target.value,
                        }))
                      }
                    />
                  </div>

                  <div className="col-8 mb-3">
                    <label>Street</label>
                    <textarea
                      className="form-control"
                      placeholder="Enter Address"
                      // style={prefillStyle}
                      //   disabled={isReadOnly && !!formData.street}
                      value={formData.street}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          street: e.target.value,
                        }))
                      }
                    />
                  </div>

                  <div className="col-3 mb-3">
                    <label>City</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="enter city"
                      // style={prefillStyle}
                      //   disabled={isReadOnly && !!formData.city}
                      value={formData.city}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          city: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="col-3 mb-3">
                    <label>State</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="state"
                      // style={prefillStyle}
                      //   disabled={isReadOnly && !!formData.state}
                      value={formData.state}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          state: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="col-3 mb-3">
                    <label>Country</label>
                    <Select
                      placeholder="select country"
                      options={countries}
                      // style={prefillStyle}
                      // styles={prefillSelectStyles}
                      //   isDisabled={isSelectReadOnly(selectedCountry)}
                      value={selectedCountry}
                      onChange={(option) => {
                        setSelectedCountry(option);

                        setFormData((prev) => ({
                          ...prev,
                          country: option?.value || null,
                        }));
                      }}
                    />
                  </div>
                  <div className="col-3 mb-3">
                    <label>Zip Code</label>
                    <input
                      type="text"
                      placeholder="enter zip"
                      className="form-control"
                      // style={prefillStyle}
                      //   disabled={isReadOnly && !!formData.zip}
                      value={formData.zip}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          zip: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
              </>
            ),
          },
        ]
      : []),

    {
      key: "items",
      label: (
        <>
          <i className="bi bi-cart3 me-2"></i>
          Items & Totals
        </>
      ),
      children: (
        <>
          <EditProducttable
            currencyId={productData.currencyId}
            CurrencyName={productData.currencyName}
            discount_type={productData.discountType}
            discount_type_id={productData.discountTypeId}
            initialDiscountPercent={productData.discount_percent}
            initialDiscountTotal={productData.discount_total}
            initialDiscount={productData.discount}
            initialItems={productData.items}
            adjustment={productData.adjustment}
            onProductDataChange={handleProductDataChange}
          />
        </>
      ),
    },

    {
      key: "terms",
      label: (
        <>
          <i className="bi bi-file-text me-2"></i>
          Terms & Conditions
        </>
      ),
      children: (
        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <label className="form-label">Terms & Conditions</label>

              <textarea
                className="form-control"
                rows={8}
                name={type === "proposal" ? "content" : "terms"}
                value={
                  type === "proposal"
                    ? formData.content || ""
                    : formData.terms || ""
                }
                onChange={(e) => {
                  const value = e.target.value;

                  setFormData((prev) => ({
                    ...prev,
                    ...(type === "proposal"
                      ? { content: value }
                      : { terms: value }),
                  }));
                }}
                placeholder="Enter terms and conditions"
              />
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      {(loading || saving) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="content">
        <div className="page-header">
          <div className="add-item">
            <div className="d-flex flex-column">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/crm/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item" aria-current="page">
                    Update {formattedType}
                  </h4>
                </ol>
              </nav>
              <p className="text-muted">
                Review and update your {formattedType} details here
              </p>
            </div>
          </div>

          <div className="">
            <Link
              to={backPaths[type]}
              className="btn btn-dark btn-icon btn-sm "
            >
              <i className="fa-solid fa-arrow-left fa-lg text-white"></i>
            </Link>
          </div>
        </div>

        <div className="card">
          {/* <div className="card-header ">
            <h4 className="text-primary">{formData.client}</h4>
          </div> */}
          <div className="card-body pt-0 ">
            <form
              onSubmit={handleUpdate}
              onKeyDown={(e) => {
                if (
                  e.key === "Enter" &&
                  e.target.tagName !== "TEXTAREA" &&
                  e.target.tagName !== "INPUT"
                ) {
                  e.preventDefault();
                }
              }}
            >
              <Tabs
                // defaultActiveKey="1"
                activeKey={activeTab}
                onChange={setActiveTab}
                items={tabItems}
                size="large"
                tabBarGutter={30}
                animated
              />

              {/* <div className="d-flex justify-content-end mt-2"> */}
              {/* <button
                  type="submit"
                  className="btn btn-info me-2"
            
                >
                  Save & Send
                </button>

                <button
                  type="submit"
                  className="btn btn-primary"
               
                  disabled={saving}
                >
                  {saving ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Saving...
                    </>
                  ) : (
                    "Save"
                  )}
                </button> */}

              <div className="d-flex justify-content-end gap-2 mt-3">
                {activeTab !== "basic" && (
                  <button
                    type="button"
                    onClick={handlePrevious}
                    className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                    style={{
                      width: "35px",
                      height: "35px",
                      backgroundColor: "#6c757d",
                      color: "#fff",
                      border: "none",
                    }}
                    title="Previous"
                  >
                    {" "}
                    <i className="fa fa-arrow-left" />{" "}
                  </button>
                )}{" "}
                {activeTab !== "terms" && (
                  <button
                    type="button"
                    onClick={handleNext}
                    className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                    style={{
                      width: "35px",
                      height: "35px",
                      backgroundColor: "#f1f51e",
                      color: "#fff",
                      border: "none",
                    }}
                    title="Next"
                  >
                    <i className="fa fa-arrow-right" />
                  </button>
                )}
                {activeTab === "terms" && (
                  <button
                    type="submit"
                    disabled={saving}
                    className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                    style={{
                      width: "35px",
                      height: "35px",
                      backgroundColor: "#07f083",
                      color: "#fff",
                      border: "none",
                    }}
                    title="Save"
                  >
                    {saving ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                      />
                    ) : (
                      <i className="fa fa-check" />
                    )}
                  </button>
                )}
              </div>
              {/* </div> */}
            </form>
          </div>
        </div>

        <CommonFooter />
      </div>
    </div>
  );
};

export default Update;
